// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__X_yts","actions":"style_actions__3qOWJ"};